var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "box view-nav-bar" },
      [
        _c("b-form-input", {
          staticClass: "transparent-input",
          attrs: {
            type: "search",
            debounce: "400",
            placeholder: "Source title",
          },
          model: {
            value: _vm.searchTitle,
            callback: function ($$v) {
              _vm.searchTitle = $$v
            },
            expression: "searchTitle",
          },
        }),
        _vm._v(" "),
        _c("multi-select", {
          attrs: {
            options: Object.keys(_vm.$config.playlistStatusColorMap),
            placeholder: "Status",
            selectLabel: "",
            taggable: true,
            multiple: true,
            searchable: false,
          },
          model: {
            value: _vm.filterStatus,
            callback: function ($$v) {
              _vm.filterStatus = $$v
            },
            expression: "filterStatus",
          },
        }),
        _vm._v(" "),
        _c("multi-select", {
          attrs: {
            options: _vm.theatres,
            placeholder: "Theatre",
            selectLabel: "",
            "track-by": "code",
            label: "name",
            searchable: true,
          },
          model: {
            value: _vm.theatre,
            callback: function ($$v) {
              _vm.theatre = $$v
            },
            expression: "theatre",
          },
        }),
        _vm._v(" "),
        _vm.totalRows !== null
          ? _c("b-pagination", {
              attrs: {
                "total-rows": _vm.totalRows,
                "per-page": _vm.perPage,
                "aria-controls": "data-table",
              },
              model: {
                value: _vm.currentPage,
                callback: function ($$v) {
                  _vm.currentPage = $$v
                },
                expression: "currentPage",
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "box" }, [
      _c(
        "div",
        { class: "box-content pt-3" + (_vm.totalRows ? "" : " d-none") },
        [
          _c("b-table", {
            ref: "dataTable",
            staticClass: "shx-table w-100",
            attrs: {
              id: "data-table",
              hover: "",
              dark: "",
              fixed: "",
              "sort-icon-left": "",
              fields: _vm.columns,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
              currentPage: _vm.currentPage,
              perPage: 0,
              items: _vm.fetchData,
            },
            on: {
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function ($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.sortDesc = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "cell(status)",
                fn: function (row) {
                  return [
                    _c("playlist-badge", {
                      attrs: { status: row.item.status },
                    }),
                  ]
                },
              },
              {
                key: "cell(playlist_provider_id)",
                fn: function (row) {
                  return [
                    _vm._v(
                      "\n                    " +
                        _vm._s(row.item.raw.feature.title) +
                        " ("
                    ),
                    _c("movix-link", { attrs: { id: row.item.movix_id } }),
                    _vm._v(")"),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-muted" }, [
                      _vm._v(
                        _vm._s(row.item.playlist_provider_id) +
                          "\n                        v" +
                          _vm._s(row.item.playlist_provider_version)
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "cell(session_exhibitor_id)",
                fn: function (row) {
                  return [
                    _vm._v(
                      "\n                    Exhibitor ID:\n                    "
                    ),
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: `/sessions/${row.item.session_exhibitor_id}/playlists`,
                        },
                      },
                      [_vm._v(_vm._s(row.item.session_exhibitor_id))]
                    ),
                  ]
                },
              },
              {
                key: "cell(screens)",
                fn: function (row) {
                  return [
                    _vm._v(
                      "\n                    " +
                        _vm._s(row.item.screens.join()) +
                        "\n                "
                    ),
                  ]
                },
              },
              {
                key: "cell(block_count)",
                fn: function (row) {
                  return [
                    _c("span", [_vm._v(_vm._s(row.item.block_count))]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn",
                        on: {
                          click: function ($event) {
                            return _vm.downloadJsonData(
                              "playlist-raw",
                              row.item.raw
                            )
                          },
                        },
                      },
                      [_c("icon", { attrs: { name: "download" } })],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.totalRows
        ? _c(
            "div",
            { staticClass: "box-content pt-3 text-center text-muted" },
            [_vm._v("No playlists yet.")]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "box" },
      [
        _vm.totalRows !== null
          ? _c("b-pagination", {
              attrs: {
                "total-rows": _vm.totalRows,
                "per-page": _vm.perPage,
                "aria-controls": "data-table",
              },
              model: {
                value: _vm.currentPage,
                callback: function ($$v) {
                  _vm.currentPage = $$v
                },
                expression: "currentPage",
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }